/**
 * Files served next to loader.js on the CDN: the fallback mascot and avatar,
 * and the Figtree font.
 *
 * Resolved against the loader's own URL, so they are absolute on the
 * customer's page (a relative path would resolve against their site).
 */

const FONT_STYLE_ID = 'chatbot-widget-fonts';

// Our own family name, so the customer's page can never get or lose "Figtree"
// because of us.
export const FONT_FAMILY = 'Chatbot Figtree';

export function assetBase(script) {
  try {
    return new URL('assets/', script.src).href;
  } catch {
    return null;
  }
}

export function fallbackImages(base) {
  return base
    ? { launcher: `${base}mascot.webp`, avatar: `${base}avatar.webp` }
    : { launcher: null, avatar: null };
}

/**
 * Declares the font on the page, once.
 *
 * @font-face inside a shadow root is ignored by browsers, so the declaration
 * has to live in the document. It only declares a family nothing on the page
 * uses; no style of the page changes. Served from our CDN, never from Google
 * Fonts: no third party learns about the customer's visitors.
 */
export function declareFont(base, doc = document) {
  if (!base || doc.getElementById(FONT_STYLE_ID)) return;
  const style = doc.createElement('style');
  style.id = FONT_STYLE_ID;
  style.textContent = `
    @font-face {
      font-family: "${FONT_FAMILY}"; font-style: normal; font-weight: 400 700; font-display: swap;
      src: url("${base}figtree-latin-ext.woff2") format("woff2");
      unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }
    @font-face {
      font-family: "${FONT_FAMILY}"; font-style: normal; font-weight: 400 700; font-display: swap;
      src: url("${base}figtree-latin.woff2") format("woff2");
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }`;
  doc.head.appendChild(style);
}

/**
 * An image that never shows broken: when the customer's image fails (their
 * server down, a certificate the browser refuses), our own default from the
 * CDN; when that fails too, no image at all.
 */
export function withFallback(img, fallback) {
  img.addEventListener('error', () => {
    if (fallback && img.getAttribute('src') !== fallback) {
      img.setAttribute('src', fallback);
    } else {
      img.remove();
    }
  });
  return img;
}
